import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Learnset } from 'src/app/models/learnset.model';
import { SharedModule } from '../shared.module';
import { TablerIconComponent } from 'angular-tabler-icons';
import { EditLearnsetModule } from 'src/app/features/learnset-view/edit-learnset/edit-learnset.module';
import { LearnsetService } from 'src/app/core/learnset.service';

@Component({
  selector: 'app-learnsets-list',
  templateUrl: './learnsets-list.component.html',
  styleUrls: ['./learnsets-list.component.scss'],
  imports: [
    CommonModule,
    SharedModule,
    TablerIconComponent,
    EditLearnsetModule
  ]
})
export class LearnsetsListComponent {

  @Input() allowActions: boolean = true;

  @Input() learnsets: any;
  @Output() learnsetClicked: EventEmitter<Learnset> = new EventEmitter<Learnset>();

  editLearnsetVisible: boolean = false;
  learnsetToEdit?: Learnset;

  constructor(
    private learnsetService: LearnsetService
  ) {}

  ngOnInit() {}

  handleLearnsetClick(learnset: Learnset) {
    this.learnsetClicked.emit(learnset);
  }

  editLearnset(event: Event, learnset: Learnset) {
    event.stopPropagation();
    this.learnsetToEdit = learnset;
    this.editLearnsetVisible = true;
  }

  deleteLearnset(event: Event, learnset: Learnset) {
    event.stopPropagation();
    this.learnsetService.deleteLearnset(learnset.id!).subscribe(() => {
      this.learnsets.splice(this.learnsets.indexOf(learnset), 1);
    });
  }
}
